<div class="table-item">{{ question.question }}</div>
<div class="table-item">{{ question.right + question.wrong }}</div>
<div class="table-item">{{ correctChoice.text }}</div>
<div class="table-item">{{ question.right }}</div>
<div class="table-item">{{ question.wrong }}</div>
<div class="table-item">{{ question.wildcard }}</div>
<div class="table-item">{{ question.createdByEmail || '--' }}</div>
<div class="table-item">{{ status | translate }}</div>
<div class="table-item">{{ question.likes }}</div>
<div class="table-item">{{ question.dislikes }}</div>
<div class="table-item">{{ question.created_at | date : 'dd/MM/yyyy HH:mm' }}</div>
<div class="table-item">
  <lms-button-actions [items]="buttonList" [iconSize]="'small'" (change)="selectAction($event)"></lms-button-actions>
</div>
